var _path, _circle, _path2, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcNoResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 154,
    viewBox: "0 0 165 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.463 140.574C98.6263 145.23 86.1596 144.428 74.9083 142.255C43.3492 136.163 16.4321 120.06 3.18939 89.6053C-4.01124 73.0458 3.88633 45.4053 29.0589 45.9792C49.8565 46.4534 63.7394 45.2479 74.4983 33.2184C84.4226 22.1218 90.2615 9.04961 106.22 6.70643C133.311 2.72879 147.346 37.3594 136.209 58.7588C129.113 72.392 124.15 91.5387 124.15 107.205C124.15 110.933 124.327 114.712 124.131 118.434C123.63 127.985 118.349 136.757 109.463 140.574Z",
    fill: "#D9E4FE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 69.6228,
    cy: 59.0771,
    r: 39.8299,
    transform: "rotate(-45 69.6228 59.0771)",
    stroke: "#066FF9",
    strokeWidth: 3.6209,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1055 79.5596C78.7931 90.872 60.4521 90.872 49.1396 79.5596",
    stroke: "#066FF9",
    strokeWidth: 3.6209,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 105.469,
    y1: 94.9219,
    x2: 133.633,
    y2: 123.086,
    stroke: "#066FF9",
    strokeWidth: 3.6209,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNoResults);
export default __webpack_public_path__ + "static/media/ic_no-results.2ba76178fcbea0d5c37176fbcf34f5ce.svg";
export { ForwardRef as ReactComponent };